import { Box, Button, Grid, InputAdornment, TextField } from '@mui/material';
import React, { useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import Iconify from '../../../../../components/Iconify';
import SelectInput from '../../../../../components/hook-form/SelectInput';
import CustomDateRangePicker from '../../../../../components/input/CustomDatePicker';
import { fCustomDate } from '../../../../../utils/formatTime';
import { IMMERSVE_STATUSES } from '../../../../../utils/apiUrl';
import { adminApi } from '../../../../../utils/axios';
import { resetImmersveKycListFilters, setImmersveKycListFilters } from '../../../../../redux/slices/filters';

const ImmersveKycFilter = () => {
  const currentDate = new Date();

  // Getting Date which is 30 Days back from current date
  const thirtyDaysAgo = new Date();
  thirtyDaysAgo.setDate(currentDate.getDate() - 30);
  const [transactionStatusData, setTransactionStatusData] = useState([]);

  const { immersveListKycFilters } = useSelector((state) => state.filters);
  const dispatch = useDispatch();

  useEffect(() => {
    getTransactionStatusData();
  }, []);

  // Getting Status data
  const getTransactionStatusData = async () => {
    try {
      const response = await adminApi.get(IMMERSVE_STATUSES);
      setTransactionStatusData(response?.data.data.map((data) => ({ label: data.name, value: data.value })));
    } catch (error) {
      console.log(error);
    }
  };

  return (
    <Box sx={{ margin: '20px 24px' }}>
      <Grid container spacing={3}>
        <Grid item xs={12} md={4} lg={2}>
          <Button
            sx={{ paddingBlock: '15px', width: '100%' }}
            variant="contained"
            endIcon={<Iconify icon={'material-symbols:filter-list-rounded'} />}
            onClick={() => dispatch(setImmersveKycListFilters({ showFilters: !immersveListKycFilters?.showFilters }))}
          >
            Filters
          </Button>
        </Grid>
      </Grid>
      {immersveListKycFilters?.showFilters && (
        <>
          <Grid container spacing={3} sx={{ marginTop: '0px' }}>
            <Grid item xs={12} md={6} lg={6}>
              <CustomDateRangePicker
                label1="Start Date"
                label2="End Date"
                name1="from_date"
                name2="to_date"
                onChange={(e, name) =>
                  dispatch(setImmersveKycListFilters({ [name]: e === null ? '' : fCustomDate(e) }))
                }
                val1={immersveListKycFilters?.from_date}
                val2={immersveListKycFilters?.to_date}
              />
            </Grid>
            <Grid item xs={12} md={6} lg={6} sx={{ textAlign: 'right' }}>
              <Button
                sx={{ paddingBlock: '15px' }}
                variant="contained"
                onClick={() => dispatch(resetImmersveKycListFilters())}
              >
                Reset Filters
              </Button>
            </Grid>
          </Grid>
          <Grid container spacing={3} sx={{ marginTop: '0px' }}>
            <Grid item xs={12} md={6} lg={6}>
              <TextField
                fullWidth
                onChange={(event) => dispatch(setImmersveKycListFilters({ search: event.target.value }))}
                placeholder="Search by ID, Name, Phone and Email"
                value={immersveListKycFilters.search}
                InputProps={{
                  startAdornment: (
                    <InputAdornment position="start">
                      <Iconify icon={'eva:search-fill'} sx={{ color: 'text.disabled', width: 20, height: 20 }} />
                    </InputAdornment>
                  ),
                }}
              />
            </Grid>

            <Grid item xs={12} md={3} lg={3}>
              <SelectInput
                label="Status"
                optionsRole={transactionStatusData}
                onChange={(event) => dispatch(setImmersveKycListFilters({ status: event.target.value }))}
                value={immersveListKycFilters.status}
                name="status"
                isClear={() => dispatch(setImmersveKycListFilters({ status: '' }))}
              />
            </Grid>
          </Grid>
        </>
      )}
    </Box>
  );
};

export default ImmersveKycFilter;
